"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M15.5 7.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M18 17.9c0 1.933-3.6 2.1-6 2.1s-6-.167-6-2.1S7.8 13 12 13s6 2.967 6 4.9M8.058 5.327c.148-.267.07-.619-.222-.706a2.917 2.917 0 1 0-.094 5.617c.295-.077.385-.426.246-.697A4.5 4.5 0 0 1 7.5 7.5c0-.788.202-1.529.558-2.173m7.954 4.213A4.5 4.5 0 0 0 16.5 7.5a4.5 4.5 0 0 0-.558-2.173c-.148-.267-.07-.618.222-.705Q16.563 4.5 17 4.5a2.917 2.917 0 1 1-.744 5.738c-.294-.078-.384-.426-.245-.698"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M8.096 12.087c.45.075.462.663.07.896a6.58 6.58 0 0 0-3.058 4.293c-.055.267-.294.465-.564.429-1.369-.182-2.543-.614-2.543-1.622 0-1.61 1.5-4.083 5-4.083q.584 0 1.095.087m11.359 5.618c-.27.036-.509-.162-.563-.429a6.58 6.58 0 0 0-3.058-4.293c-.392-.232-.38-.82.07-.895A7 7 0 0 1 17.001 12c3.5 0 5 2.473 5 4.083 0 1.009-1.176 1.44-2.546 1.622"
  })]
}), 'ConsultantNetworkFilled');
//# sourceMappingURL=index.js.map